import React from 'react';
import { connect } from 'react-redux';
import { VIEW } from '../../constants/appConstants';

import './Footer.css';

const Footer = (props) => {
  const isActive = (view) => props.view.current === view;
  
  const newWindowItem = props.isAuthorized ? (
    <div className={ isActive(VIEW.NEW_WINDOW_VIEW) ? 'clsAppBtn active' : 'clsAppBtn' }>
      <a className="fa fa-plus-square fa-2x clsAppBtn-icon" onClick={ () => props.setView(VIEW.NEW_WINDOW_VIEW) }></a>
      <label className='clsAppBtn-label'>New Window</label>
    </div> 
  ) : null;

  const myWindowsItem = props.isAuthorized ? (
    <div className={ isActive(VIEW.MY_WINDOW_VIEW) ? 'clsAppBtn active' : 'clsAppBtn' }>
      <a className="fa fa-user fa-2x clsAppBtn-icon" onClick={ () => props.setView(VIEW.MY_WINDOW_VIEW) }></a>
      <label className='clsAppBtn-label'>My Windows</label>
    </div>
  ) : null;

  return (
    <div className='clsFooter'>
      <div className={ isActive(VIEW.HOME_VIEW) ? 'clsAppBtn active' : 'clsAppBtn' }>
        <a className="fa fa-home fa-2x clsAppBtn-icon" onClick={ () => props.setView(VIEW.HOME_VIEW) }></a>
        <label className='clsAppBtn-label'>Home</label>
      </div>
      { newWindowItem }
      { myWindowsItem }
      { 
        (props.view.current === VIEW.WINDOW_LIST_VIEW || 
            props.view.current === VIEW.MY_WINDOW_VIEW) ? 
            (
              <div className='clsAppBtn'>
                <a className="fa fa-filter fa-2x clsAppBtn-icon" onClick={ () => props.showFilter(true) }></a>
                <label className='clsAppBtn-label'>Filter</label>
              </div>
            ) : null
      }        
    </div>
  );
}

function mapStateToProps(state) {
  return {    
    view: state.view,
    isAuthorized: state.isAuthorized
  };
}

const mapDispatchToProps = dispatch => {
  return {  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);